import { memo, useRef } from "react";
import { Modal } from "@mui/material";
import { ReactSVG } from "react-svg";
import { VitaPercent } from "Components/Buttons/VitaPercent";
import { cats } from "JSON/PSP";

export const MedicamentsGroup = memo(function MedicamentsGroupComponents({
  open,
  close,
  data = undefined,
}: {
  open: boolean;
  close: () => void;
  data?: any;
}) {
  const containerRef = useRef(null);
  const mapper = data ? data : cats;
  return (
    <>
      <div ref={containerRef}></div>
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        container={containerRef.current}
        className="flex items-center justify-center"
      >
        <div className="w-[644px] sm:w-[100dvh] sm:max-w-full sm:max-h-full sm:rounded-[0px] sm:h-[100dvh] overflow-hidden flex flex-col p-[24px] sm:p-[12px] relative max-w-[90%] max-h-[90%] h-[604px] bg-[#fff] rounded-[12px] outline-none">
          <div className="mb-[24px] flex justify-between items-center">
            <h2 className="font-bold text-[20px] text-blackPrimary-100">
              მედიკამენტების ჯგუფები
            </h2>
            <div
              onClick={close}
              className="cursor-pointer w-[44px] h-[44px] bg-gray-30 sm:bg-gray-100 sm:rounded-[8px] rounded-[50%] flex items-center justify-center"
            >
              <ReactSVG src="/images/icons/close.svg" />
            </div>
          </div>
          <div className="customScrolllbar overflow-y-auto h-[100vh-40px]">
            {mapper.map((item: any, index: number) => (
              <div
                className="flex items-center gap-4 py-[16px] border-b-[1px] border-solid border-b-gray-30"
                key={index}
              >
                <div className="flex gap-1 flex-wrap">
                  <h2 className="text-blackPrimary-60 font-demi text-md">
                    {item?.title}
                  </h2>
                </div>
                <div className="ml-auto">
                  <VitaPercent icon={false} percent={item?.discount} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
});
